import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const CompanyPage = lazy(() => import('../pages/company/page'));
const DemolitionPage = lazy(() => import('../pages/demolition/page'));
const RealEstatePage = lazy(() => import('../pages/real-estate/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/company',
    element: <CompanyPage />,
  },
  {
    path: '/demolition',
    element: <DemolitionPage />,
  },
  {
    path: '/real-estate',
    element: <RealEstatePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
